<template>
    <v-container style="padding-top: 100px;">
        <v-flex xs12 sm12>
            <v-chip class="ma-2" :color="this.color" large>
                <span style="color: white;padding-right: 10px;font-size: 20px;"> Reporte: {{ this.RepInd }}</span>
                <div
                    style=" font-size: 16px; background-color: white; color:black; border-radius: 25px; padding: 6% 2% 6% 2%; font-weight: bold;">
                    {{ this.etiqueta }}</div>
            </v-chip>
        </v-flex>
        <v-card style="height: 50% !important; borde:none;" id="DatosGenerales">
            <v-tabs v-model="tabs" centered>
                <v-tab @click="pushTo('detalleGeneral')"> Detalle General </v-tab>
                <v-tab> </v-tab>
            </v-tabs>
            <v-tabs-items class="container">
                <router-view></router-view>
            </v-tabs-items>
        </v-card>
    </v-container>
</template>


<script>
import { mapActions, mapState } from 'vuex';
import Reporte from '@/services/reporteVial/ReporteVial.service.js';
export default {
    components: {
    },
    data: function () {
        return {
            tabs: '',
            RepInd: '',
            color: '',
            etiqueta: '',
        };
    },

    computed: {
        ...mapState({ drawer: state => state.drawer }),
        ...mapState(['domain', 'informationPage']),
        DRAWER_STATE: {
            get() {
                return this.drawer
            },
        }
    },
    mounted() {

    },
    updated() {
        this.getInitialData();
    },
    methods: {
        async getInitialData() {
            let encabezado = await Reporte.EncabezadoReporte(this);
            this.RepInd = encabezado.nrreportei;
            this.color = encabezado.color;
            this.etiqueta = encabezado.etiqueta;
        },
        pushTo(param) {
            switch (param) {
                case 'detalles':
                    this.$router.push({ name: `ReporteDetalleVial` });
                    break;
            }
        },
    }
};
</script>
<style scoped>
.mdi-check-circle-outline {
    color: #3CD4A0 !important;
}

.mdi-checkbox-marked {
    color: #3CD4A0 !important;
}

.mdi-home,
.mdi-cellphone,
.mdi-briefcase {
    color: #3CD4A0 !important;
}

#DetalleReporte .vs-list--subtitle {
    font-size: 20px;
    font-weight: 700;
}

#DetalleReporte .vs-list--title {
    font-size: 12.8px;
    font-weight: 700;
}

#titulocard {
    color: white;
}
</style>